export const SortTypes = {
    DEFAULT: "Default",
    CLIENT_NAME: "ClientName",
    CLIENT_ACTIVITY: "LastClientActivity",
    RECENTLY_ASSIGNED: "RecentlyAssigned",
    READY_TO_ASSIGN: "ReadyToAssign",
    CLOSED_COMPLETED_IN_OFFICE: "ClosedCompletedInOffice",
    CLOSED_INCOMPLETE: "ClosedIncomplete",    
    NEW_TICKETS: "NewTickets",
    PREPARE_RETURN: "PrepareReturn",
    REVIEW_DOCUMENTS: "ReviewDocuments",
    CLIENT_APPROVALS: "ClientApprovals",
    PREPARE_PAYMENT: "PreparePayment",
    FILE_RETURN: "FileReturn",
    WORKFLOW_STATE_IDENTIFIER: "workflowStateIdentifier",
    HAS_UNREAD_MESSAGES: "hasUnreadMessage",
    TICKET_CLIENT_NAME:"nameEn",
    TICKET_STATUS:"ticketWorkflowStatus",
    CLIENT_LAST_ACTIVITY: "clientLastActivity",
}

export const FilterTypes = {
    PREPARE_RETURN: "prepareReturn",
    PREPARE_PAYMENT: "preparePayment",
    FILE_RETURN: "fileReturn",
    CLIENT_ACTION: "clientAction",
    HAS_UNREAD_MESSAGES: "hasUnreadMessage",
    CLOSED_TICKETS_ONLY: "closedTicketsOnly",
    REVIEW_DOCUMENTS: "reviewDocuments"
}

export const FilterWorkflowMappingKeywords = {
    prepareReturn: ['VDO_WORKING', 'RTE_WORKING', 'RTEDR_WORKING'],
    preparePayment: ['VDO_PAYMENT', 'RTE_PREPARE_PAYMENT', 'RTEDR_PREPARE_PAYMENT'],
    fileReturn: ['VIR_CLIENT_CALL_PAYMENT', 'VIR_FILE_RETURN', 'RTE_FILE', 'RTEDR_FILE'],
    clientAction: ['VIR_REVIEW_C', 'VDO_REVIEW', 'RTE_REVIEW', 'RTE_PAYMENT', 'RTEDR_REVIEW', 'RTEDR_PAYMENT'],
    reviewDocuments: ['RTEDR_DOCUMENT_REVIEW']
}